import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;
export default {
    state: {
        notes: [],
        noteFiles: [],
        noteFilesId: null,
    },
    getters: {
        notes: (state) => state.notes,
        noteFiles: (state) => state.noteFiles,
        noteFilesId: (state) => state.noteFilesId,
    },
    mutations: {
        setNotes: (state, data) => { state.notes = data; },
        setNoteFiles: (state, data) => { state.noteFiles = data; },
        setNoteFilesId: (state, data) => { state.noteFilesId = data; },
    },
    actions: { 
        getNotes: async ({ commit, dispatch }, id) => {
            try {
                const response = await api({ requiresAuth: true }).get(`v1/customer-notes/${id}`);
                const { data } = response.data;
                commit("setNotes", data);
                return data;
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || t("messages.failedToLoadNotes") 
                });
                throw error;
            }
        },

        createNotes: async ({ dispatch }, payload) => {
            try {
                const response = await api({ requiresAuth: true }).post("v1/notes", payload);
                await dispatch("getNotes", payload.customer_id);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || t("messages.noteCreatedSuccessfully") 
                });
                return response.data.data.id;
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || t("messages.failedToCreateNote")
                });
                throw error;
            }
        },

        deleteNotes: async ({ dispatch }, { noteId, customerId }) => {
            try {
                const response = await api({ requiresAuth: true }).delete(`v1/notes/${noteId}`);
                await dispatch("getNotes", customerId);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || t("messages.noteDeletedSuccessfully")
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || t("messages.failedToDeleteNote") 
                });
                throw error;
            }
        },

        updateNotes: async ({ dispatch }, payload) => {
            try {
                const response = await api({ requiresAuth: true }).patch(`v1/notes/${payload.id}`, payload);
                await dispatch("getNotes", payload.customer_id);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || t("messages.noteUpdatedSuccessfully") 
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || t("messages.updateFailed")
                });
                throw error;
            }
        },

        addNotesFile: async ({ dispatch }, { noteId, files }) => {
            try {
                const formData = new FormData();
                files.forEach(file => formData.append("note_files[]", file));
                
                const response = await api({ requiresAuth: true }).post(
                    `v1/notes/${noteId}/files`, 
                    formData, 
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || t("messages.filesUploadedSuccessfully") 
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || t("messages.failedToUploadFile") 
                });
                throw error;
            }
        },

        fetchNoteFiles: async ({ commit, dispatch }, noteId) => {
            try {
                const response = await api({ requiresAuth: true }).get(`/v1/notes/${noteId}`);
                const { data } = response.data; 
                commit("setFilesToEdit", data.files, { root: true });
                return data;
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || t("messages.failedToLoadNoteFiles")
                });
                throw error;
            }
        },

        markNoteAsComplete: async ({ dispatch }, { noteId }) => {
            try {
                const response = await api({ requiresAuth: true }).patch(`v1/notes/${noteId}/mark-done`);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || t("messages.taskCompleted") 
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || t("messages.failedToCompleteTask") 
                });
                throw error;
            }
        }
    },
}
